import { ConditionalWrapper } from '@cian/conditional-component';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';
import { useObserveColumnsWidths } from './utils/useObserveColumnsWidths';
import { ScrollableWrapper } from '../../commonComponents';
import { HeaderRow } from '../HeaderRow';
import { WideOfferRow } from '../WideOfferRow';
import { IOffersFeedProps } from '../../../../../containers/OfferHistory/types';

type TWideOffersFeedProps = Omit<IOffersFeedProps, 'feedViewState'>;

export const WideOffersFeed: React.VFC<TWideOffersFeedProps> = ({
  scrollable,
  selectable,
  data,
  showMoreBtn,
  activeOfferId,
  onOfferClick,
  viewedOffers,
}) => {
  const { containerRef, rowRef, widths } = useObserveColumnsWidths();

  return (
    <ConditionalWrapper
      if={Boolean(scrollable)}
      className={scrollable ? styles['scrollable'] : undefined}
      ThenComponent={ScrollableWrapper}
    >
      <>
        <div className={styles['grid']}>
          <HeaderRow columnsWidths={widths} />
        </div>
        <div ref={containerRef} className={cn(styles['grid'], styles['content'])}>
          {data.map((offer, i) => (
            <WideOfferRow
              key={offer.id}
              ref={i === 0 ? rowRef : undefined}
              data={offer}
              selectable={selectable}
              isActive={offer.id === activeOfferId}
              isViewed={viewedOffers.includes(offer.id)}
              onClick={() => onOfferClick(offer.id)}
              testId={`offers_history_listing_item_${offer.id}`}
            />
          ))}
          {showMoreBtn && <div className={styles['show-more']}>{showMoreBtn}</div>}
        </div>
      </>
    </ConditionalWrapper>
  );
};
